function createOverlay(image) {
  const overlay = document.createElement('div');
  const overlayImage = document.createElement('img');
  overlayImage.src = image.src;

  overlay.classList.add('image-magnify-full-size');
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.backgroundImage = `url('${image.src}')`;
  overlay.style.backgroundColor = 'var(--gradient-background)';
  overlay.style.display = 'block';

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';

    overlay.onmousemove = (event) => moveWithHover(image, overlay, event, 2);
    overlay.onmouseleave = () => overlay.remove();
    overlay.onclick = () => overlay.remove();
  };

  return overlay;
}

function toggleLoadingSpinner(image) {
  const spinner = image.closest('.product-image-container')?.querySelector('.loading__spinner');
  if (spinner) {
    spinner.classList.toggle('hidden');
  }
}

function moveWithHover(image, overlay, event, zoomRatio) {
  const rect = image.getBoundingClientRect();
  const x = event.clientX - rect.left;
  const y = event.clientY - rect.top;
  const xPercent = (x / image.clientWidth) * 100;
  const yPercent = (y / image.clientHeight) * 100;

  overlay.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');

  images.forEach((image) => {
    image.addEventListener('click', (event) => {
      event.preventDefault();
      const existingOverlay = image.parentElement.querySelector('.image-magnify-full-size');
      if (!existingOverlay) {
        createOverlay(image);
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  enableZoomOnHover(2);
});
